import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import ModalWindow from './ModalWindow.react';
var ModalContainer = function ModalContainer(_ref) {
  var windows = _ref.windows;
  if (windows.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "fullscreen"
  }, windows.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "overlay"
  }), windows.map(function (x) {
    return /*#__PURE__*/React.createElement(ModalWindow, {
      key: x.id
    }, x.component);
  }));
};
var mstp = function mstp(s) {
  return {
    windows: s.modal.windows
  };
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(mstp, mdtp)(ModalContainer);